import React from 'react';
import { Check } from 'lucide-react';
import HeartBubble from './HeartBubble';
import { benefits } from '../mock';

const Vorteile = () => {
  return (
    <section className="relative bg-charcoal py-20 md:py-28 overflow-hidden">
      <HeartBubble size={130} className="top-10 right-[6%] float-anim hidden md:block" rotate={12} />
      <HeartBubble size={70} className="top-40 right-[18%] float-anim-delay hidden md:block" rotate={-8} />

      <div className="max-w-4xl mx-auto px-6 relative z-10">
        <h2 className="section-title text-center mb-12">
          Deine Vorteile.
        </h2>

        <ul className="space-y-5">
          {benefits.map((b) => (
            <li key={b.title} className="flex gap-4 items-start">
              <div className="shrink-0 w-7 h-7 rounded-full bg-yellow flex items-center justify-center mt-1 border-2 border-[#1a1a1a]">
                <Check className="w-4 h-4 text-[#1a1a1a]" strokeWidth={3} />
              </div>
              <p className="text-zinc-100 leading-relaxed">
                <span className="text-yellow font-heavy">{b.title}</span>
                <span className="text-zinc-300"> – {b.text}</span>
              </p>
            </li>
          ))}
        </ul>

        <div className="mt-12 text-center">
          <a href="#contact" className="btn-yellow">
            Kostenlos anfragen
          </a>
        </div>
      </div>
    </section>
  );
};

export default Vorteile;
